export function hasSummaryValuesPermission(
  permissionType,
  permissionGroup = "vendas"
) {
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
    const summaryValuesPermission =
      permissions?.[permissionGroup]?.[permissionType]?.permissoesEspecificas
        ?.visualizarValoresResumo;

    if (typeof summaryValuesPermission === "boolean") {
      return summaryValuesPermission;
    }

    return localStorage.getItem("userLevel") === "adm";
  } catch (_) {
    return false;
  }
}
